import { GreyBoxLoader, GreyCircleLoader, TextLoader } from '@xarvio/elements';
import { ColorCx, getBgColorCx, Text } from '@xarvio/corporate-styles';
import { Box, Row, RowCell, Separator } from '@xarvio/layout';
import React from 'react';
import loadingStyles from '../../../styles/loading.module.scss';
import cx from 'classnames';
import { Actions } from '@xarvio/button';

const FILTER_LOADING_ITEM_COUNT = 5;

export const CrossFarmDashboardFilterLoading = () => {
  return (
    <div className={cx(loadingStyles.panel, getBgColorCx(ColorCx.GREY_300))}>
      <Box hpadding={'medium'} vpadding={'narrow'} margin={false}>
        <Row align={'center'} gaps={'narrow'} margin={'no'} minHeight={40}>
          <RowCell>
            <Text type={'h3'}>
              <TextLoader width={'4em'} />
            </Text>
          </RowCell>
          <RowCell auto>
            <Actions>
              <GreyBoxLoader style={{ height: 24, width: 60 }} />
              <GreyBoxLoader style={{ height: 24, width: 60 }} />
            </Actions>
          </RowCell>
        </Row>
      </Box>
      {Array.from({ length: FILTER_LOADING_ITEM_COUNT }, (_, index) => (
        <React.Fragment key={index}>
          {index > 0 && <Separator light />}
          <Box
            hpadding={'medium'}
            vpadding={'narrow'}
            margin={false}
            bg={ColorCx.WHITE_A60}
          >
            <Row align={'center'} gaps={'narrow'} margin={'no'} minHeight={34}>
              <RowCell>
                <Text type={'h5'}>
                  <TextLoader width={'6em'} />
                </Text>
              </RowCell>
              <RowCell auto>
                <GreyCircleLoader size={16} />
              </RowCell>
            </Row>
          </Box>
        </React.Fragment>
      ))}
    </div>
  );
};
